/**
 * Minimal WAV encoder — IEEE float32 stereo (format tag 3). Used by the Node
 * golden-render script for ear/FFT audits and later by the web builder's
 * offline export path.
 */

import type { StereoBuffer } from "../dsp/renderer.ts";

export function encodeWavFloat32(buffer: StereoBuffer, sampleRate: number): Uint8Array {
  const frames = buffer.left.length;
  const channels = 2;
  const bytesPerSample = 4;
  const dataBytes = frames * channels * bytesPerSample;
  const out = new ArrayBuffer(44 + dataBytes);
  const view = new DataView(out);

  const writeAscii = (offset: number, s: string) => {
    for (let i = 0; i < s.length; i++) view.setUint8(offset + i, s.charCodeAt(i));
  };

  writeAscii(0, "RIFF");
  view.setUint32(4, 36 + dataBytes, true);
  writeAscii(8, "WAVE");
  writeAscii(12, "fmt ");
  view.setUint32(16, 16, true); // fmt chunk size
  view.setUint16(20, 3, true); // IEEE float
  view.setUint16(22, channels, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * channels * bytesPerSample, true);
  view.setUint16(32, channels * bytesPerSample, true);
  view.setUint16(34, 8 * bytesPerSample, true);
  writeAscii(36, "data");
  view.setUint32(40, dataBytes, true);

  let o = 44;
  for (let i = 0; i < frames; i++) {
    view.setFloat32(o, buffer.left[i]!, true);
    view.setFloat32(o + 4, buffer.right[i]!, true);
    o += 8;
  }
  return new Uint8Array(out);
}
